<template>
  <div class="card">
    <div class="is-paddingless">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('listeProduitReseauTempo.popUpEditionPlanning.title') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messagesError"
                             :error="error"
                             :title="'general.problemOccurred'"
                             @close="error = $event"/>
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field :label="$t('listeProduitReseauTempo.popUpEditionPlanning.dateDebut')">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            icon="calendar-today"
                            v-model="dateDebut"
                            :editable="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('listeProduitReseauTempo.popUpEditionPlanning.dateFin')">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            icon="calendar-today"
                            v-model="dateFin"
                            :editable="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-6">
            <qd-checkbox
              v-model="avecInitialeCommercial"
              class="has-text-weight-bold has-text-default">
              {{ $t('listeProduitReseauTempo.popUpEditionPlanning.inclureCommercial') }}
            </qd-checkbox>
          </div>
          <div class="column is-6">
            <qd-radio v-model="format"
                     :native-value="constantes.TYPE_PDF">
              {{ $t('general.popUpEdition.type.pdf') }}
            </qd-radio>
            <qd-radio v-model="format"
                     class="mgl-10px"
                     :native-value="constantes.TYPE_DOCX">
              {{ $t('general.popUpEdition.type.docx') }}
            </qd-radio>
          </div>
        </div>
        <footer>
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="editionPlanning()">
                {{ $t('general.button.valider') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import formatDate from '@/services/general/formatIsoDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';

export default {
  data() {
    return {
      error: false,
      messagesError: [],
      dateDebut: null,
      dateFin: null,
      avecInitialeCommercial: true,
      format: TYPE_PDF,
      constantes: {
        TYPE_PDF,
        TYPE_DOCX,
      },
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    editionPlanning() {
      this.messagesError = [];
      if (moment(this.dateDebut).isAfter(moment(this.dateFin))) {
        this.messagesError.push({
          message: 'validation.dateDebutGreaterDateFin',
        });
        this.error = true;
      } else this.error = false;
      if (this.error) return;
      this.$emit('editionPlanning', {
        dateDebut: formatDate(this.dateDebut),
        dateFin: formatDate(this.dateFin),
        avecInitialeCommercial: this.avecInitialeCommercial,
      }, this.format);
    },
  },
  mounted() {
    this.dateDebut = (moment().startOf('year')).toDate();
    this.dateFin = (moment().endOf('year')).toDate();
  },
};

</script>
